"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * An enum containing the type of a session properties event.
 */
var SessionPropertiesEventType;
(function (SessionPropertiesEventType) {
    SessionPropertiesEventType[SessionPropertiesEventType["OPEN"] = 0] = "OPEN";
    SessionPropertiesEventType[SessionPropertiesEventType["UPDATE"] = 1] = "UPDATE";
    SessionPropertiesEventType[SessionPropertiesEventType["CLOSE"] = 2] = "CLOSE";
})(SessionPropertiesEventType = exports.SessionPropertiesEventType || (exports.SessionPropertiesEventType = {}));



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/session-properties-event-type.js
// module id = 572
// module chunks = 1